import {
    request,
    requestMedia,
    requestPost
}
    from './request';

export default {
    listLog(data) {
        return request ('/api/operation/list',data)
    }
}


// WEBPACK FOOTER //
// ./src/libs/axios/chatLog.js